/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetproductivitysuiteauthurlGetProductivitySuiteAuthURLResponse
 */
export interface JumboGetproductivitysuiteauthurlGetProductivitySuiteAuthURLResponse {
    /**
     * 
     * @type {string}
     * @memberof JumboGetproductivitysuiteauthurlGetProductivitySuiteAuthURLResponse
     */
    url?: string;
}

/**
 * Check if a given object implements the JumboGetproductivitysuiteauthurlGetProductivitySuiteAuthURLResponse interface.
 */
export function instanceOfJumboGetproductivitysuiteauthurlGetProductivitySuiteAuthURLResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetproductivitysuiteauthurlGetProductivitySuiteAuthURLResponseFromJSON(json: any): JumboGetproductivitysuiteauthurlGetProductivitySuiteAuthURLResponse {
    return JumboGetproductivitysuiteauthurlGetProductivitySuiteAuthURLResponseFromJSONTyped(json, false);
}

export function JumboGetproductivitysuiteauthurlGetProductivitySuiteAuthURLResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetproductivitysuiteauthurlGetProductivitySuiteAuthURLResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function JumboGetproductivitysuiteauthurlGetProductivitySuiteAuthURLResponseToJSON(value?: JumboGetproductivitysuiteauthurlGetProductivitySuiteAuthURLResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

